// extracted by mini-css-extract-plugin
module.exports = {"events-root":"styles_events-root__2vLal","btn":"styles_btn__2lBBX","img__wrapper":"styles_img__wrapper__2AtfI"};